import { ChevronRight } from '@vfit/shared-icons';
import { IAnchorBox } from './anchorBox.models';
import { AnchorBoxContainer, AnchorLabel, Container, CustomButton } from './anchorBox.style';

const AnchorBox = ({ isDarkMode, anchorLabel, anchorLink }: IAnchorBox) => {
  const handleClick = () => {
    window.location.href = anchorLink;
  };
  return (
    <AnchorBoxContainer>
      <CustomButton onClick={handleClick}>
        <Container className="anchorBox-link" darkMode={isDarkMode}>
          <AnchorLabel>{anchorLabel}</AnchorLabel>
          <ChevronRight />
        </Container>
      </CustomButton>
    </AnchorBoxContainer>
  );
};

export default AnchorBox;
